
import data from './data';
import { createContent0, createAnim0 } from '../components/graphics/example1';
import { createContent1, createAnim1 } from '../components/graphics/example2';
import { createContent2, createAnim2 } from '../components/graphics/example3';
import { createContent3, createAnim3 } from '../components/graphics/example4';
import { createContent4, createAnim4 } from '../components/graphics/example5';

/*****************************************
 * EXPORTED FUNCTIONS
 *****************************************/

const calcFunctions = {
  createContent: [
    {createContent: createContent0, createAnim: createAnim0},
    {createContent: createContent1, createAnim: createAnim1},
    {createContent: createContent2, createAnim: createAnim2},
    {createContent: createContent3, createAnim: createAnim3},
    {createContent: createContent4, createAnim: createAnim4},
  ],

  // genContentAnimMethods() {
  //   for (let i = 0; i < data.examples.length; i++) {
  //     calcFunctions.createContent.push({
  //       createContent: `createContent${i}`,
  //       createAnim: `createAnim${i}`,
  //     });
  //   }
  // },
};

export default calcFunctions;
